import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { AsyncThunk } from "@reduxjs/toolkit";

import { ConfirmationModal } from "../../../../components/ConfirmModal";
import { showCustomToast } from "../../../../components/CustomToast";
import { getCollectionPointIsUpdating } from "../../../../selectors/collectionPoint";
import { useAppDispatch } from "../../../../store";
import { IModal } from "../../../../types/modal";

type BillingChangeModalProps<TPayload> = IModal & {
  translationKey: string;
  thunk: AsyncThunk<any, TPayload, any>;
  payload: TPayload;
  isPaid?: boolean;
};

export const BillingChangeModal = <TPayload,>({
  translationKey,
  thunk,
  payload,
  isModalVisible,
  toggleModalVisibility,
  isPaid,
}: BillingChangeModalProps<TPayload>) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const isUpdating = useSelector(getCollectionPointIsUpdating);

  const handleConfirm = async () => {
    const result = await dispatch(thunk(payload));

    if (thunk.fulfilled.match(result)) {
      showCustomToast(t(`${translationKey}.successToast`), { type: "success" });
    } else if (thunk.rejected.match(result)) {
      showCustomToast(t(`${translationKey}.errorToast`), { type: "error" });
    }
  };

  const textSuffix = isPaid ? "Paid" : "Unpaid";

  return (
    <ConfirmationModal
      isModalVisible={isModalVisible}
      toggleModalVisibility={toggleModalVisibility}
      title={t(`${translationKey}.title`)}
      text={t(`${translationKey}.text${textSuffix}`)}
      confirmText={t(`${translationKey}.buttonConfirm${textSuffix}`)}
      cancelText={t(`${translationKey}.buttonDecline`)}
      isConfirming={isUpdating}
      onSuccess={handleConfirm}
    />
  );
};
